import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(LineElement, PointElement, CategoryScale, LinearScale, Tooltip, Legend);

const AnalyticsWidget = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAnalytics = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/dashboard/analytics-overview`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json',
          },
        });

        if (!res.ok) throw new Error('Failed to fetch analytics');

        const result = await res.json();
        setData(result);
      } catch (err) {
        console.error('Error loading analytics:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchAnalytics();
  }, []);

  const chartData = data ? {
    labels: data.labels,
    datasets: [
      {
        label: 'Autonomy',
        data: data.autonomy,
        borderColor: '#3b82f6', // blue
        backgroundColor: 'transparent',
        tension: 0.4,
        fill: false
      },
      {
        label: 'Relatedness',
        data: data.relatedness,
        borderColor: '#10b981', // green
        backgroundColor: 'transparent',
        tension: 0.4,
        fill: false
      },
      {
        label: 'Competence',
        data: data.competence,
        borderColor: '#8b5cf6', // purple
        backgroundColor: 'transparent',
        tension: 0.4,
        fill: false
      }
    ]
  } : null;

  const options = {
    responsive: true,
    maintainAspectRatio: false, // Ensures the chart resizes dynamically
    animation: {
      duration: 0 // Disables animation to ensure immediate resizing
    },
    layout: {
      padding: {
        top: 10, // Adjusted top padding to balance spacing
        bottom: 10 // Adjusted bottom padding to balance spacing
      }
    },
    plugins: {
      legend: {
        position: 'bottom',
        labels: { font: { size: 12 } }
      },
      tooltip: {
        backgroundColor: '#1F2937', // Dark gray tooltip
        titleFont: {
          size: 14
        },
        bodyFont: {
          size: 12
        },
        borderColor: '#4B5563',
        borderWidth: 1
      }
    },
    scales: {
      y: {
        suggestedMin: 1,
        suggestedMax: 7,
        ticks: { stepSize: 1 }
      }
    }
  };

  return (
    <div className="relative bg-gray-100 shadow-inner rounded-lg p-6 overflow-hidden">
      {/* Background pattern */}
      <span
        aria-hidden="true"
        style={{
          backgroundImage: "url('/patterns/bubbles.svg')",
          backgroundSize: "220%",
          backgroundPosition: "250px 800px",
          opacity: 0.1,
        }}
        className="pointer-events-none absolute inset-0 bg-repeat z-0"
      />
  
      {/* Foreground content */}
      <div className="relative z-10">
        <h2 className="text-2xl font-bold text-gray-800 text-center mb-2">Motivation Trends</h2>
        <p className="text-sm text-gray-500 text-center mb-6">(Last 5 Reports)</p>
  
        {loading ? (
          <p className="text-sm text-gray-500 animate-pulse text-center">Loading analytics...</p>
        ) : chartData ? (
          <div className="bg-white shadow-md rounded-lg p-6 h-[280px]">
            <Line data={chartData} options={options} />
          </div>
        ) : (
          <p className="text-sm text-gray-500 text-center">No analytics data available yet.</p>
        )}
      </div>
    </div>
  );  
};

export default AnalyticsWidget;
